module.exports = __webpack_public_path__ + "static/media/maven.b39fbf67.png";